<template>

<div style="text-align: center;padding: 20px;font-size: 2rem">
  <h4>{{formLabelAlign.title}}</h4>
  <h1>￥{{formLabelAlign.amt}}</h1>
  <el-button @click="topay" style="width: 100%" type="success">立即支付</el-button>
</div>

</template>
<script>
import axios from 'axios'
 const checkAndSaveWxMpOpenid=(code, url) =>{
   var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) != "micromessenger") {
    return
  }
  if(localStorage.getItem("openid")){
    return ;
  }
  if(code != null && code != undefined){
    axios({
      method: 'get',
      url: 'https://mp.klgeek.com/wx/wxAuth/codeToOpenid?state='+process.env["VUE_APP_BASE_APPID"]+'&code='+code,
    }).then(function (data) {
      console.log(data.data.data)
      localStorage.setItem("openid",data.data.data);
    }).catch(function (error) {
      console.log(error)
    });
    return
  }
  let currentuUrl = window.location.href
  let wxMpCode = currentuUrl.match(/=(\S*)&state=1#/)
  if (wxMpCode !== null && wxMpCode != undefined) {
    const replaceUrl = 'https://' + window.location.host  + url +'?code=' + wxMpCode[1] + '&state=1'
    return location.replace(replaceUrl)
  }else{
    let local = encodeURIComponent("https://" + window.location.host  + url);
    //访问设置的回调地址 redirect_uri，会重定向显示带code参数的地址
    window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx8b3a080783d3a8d0"   +
        "&redirect_uri=" + local +
        "&response_type=code&scope=snsapi_base&state=1#wechat_redirect";
  }
}

 export default {
   data() {
     return {
       centerDialogVisible: false,
       wayCode:'WX_JSAPI',
       busId:'',
       busType:'creation',
       num:1,
       codeUrl:'',
       openid:'',
       formLabelAlign: {
         title: '',
         amt: '',
         cover: '',
         publicContent:"",
         privateContent:'',
         attachments:[],
         id:'',
         excerpt:'',
         createBy:''
       }
     };
   },
   mounted() {
     this.busId=this.$route.params.busId
       this.busType=this.$route.query.busType
       this.num=this.$route.query.num
       this.userId=this.$route.query.userId
     if(this.$route.query.busType){
       localStorage.setItem("busType",this.$route.query.busType);
     }
     if(this.$route.query.num){
       localStorage.setItem("num",this.$route.query.num);
     }
     if(this.$route.query.userId){
       localStorage.setItem("userId",this.$route.query.userId);
     }
     if(!localStorage.getItem("openid")){
       this.busType=localStorage.getItem("busType")
       this.num=localStorage.getItem("num")
       this.userId=localStorage.getItem("userId")
       checkAndSaveWxMpOpenid(this.$route.query.code,"/#/pay/"+this.busId)
     }
     this.detail(this.busId);
   },
   methods: {
     detail(id){
       this.$http2({
         url: `/preview/${id}?busType=`+this.busType,
         method: 'get'
       }).then((res) => {
         if(this.busType=="faka"){
           this.formLabelAlign.title=res.data.name
           this.formLabelAlign.amt=res.data.price
         }else if(this.busType=="circle"){
           this.formLabelAlign.title=res.data.name
           this.formLabelAlign.amt=res.data.price
         }else{
           this.formLabelAlign=res.data;
         }
       })
     },
     topay(){
       this.openid=localStorage.getItem("openid")
       this.$http2({
         url: `/pay?busId=${this.busId}&busType=${this.busType}&wayCode=${this.wayCode}&openid=${this.openid}&num=${this.num}&userId=${this.userId}`,
         method: 'get'
       }).then((res) => {
         if(res.data.errCode){
           this.$message({
             message: res.data.errMsg,
             type: 'error'
           });
         }
         if(res.data.payDataType=='wxapp'){
          let payData=  JSON.parse(res.data.payData);
          let that=this;
          let mchOrderNo=res.data.mchOrderNo;
           /* eslint-disable */
           WeixinJSBridge.invoke('getBrandWCPayRequest', {
                 "appId": payData.appId,//公众号名称，由商户传入
                 "timeStamp": payData.timeStamp,//时间戳，自1970年以来的秒数
                 "nonceStr": payData.nonceStr,//随机串
                 "package": payData.package,//预支付返回数据
                 "signType": payData.signType,//微信签名方式：
                 "paySign":payData.paySign //微信签名
               },
               (res)=> {
                 if (res.err_msg == "get_brand_wcpay_request:ok") {
                   // 使用以上方式判断前端返回,微信团队郑重提示：
                   //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                   // that.$router.push("/creation?mchOrderNo="+mchOrderNo);
                   if(this.busType=="creation"){
                     location.href=process.env['VUE_APP_SHARE_BASE']+ '/h5/#/pages/creation/detail?mchOrderNo='+mchOrderNo
                   }else if(this.busType=="faka"){
                     location.href=process.env['VUE_APP_SHARE_BASE']+  '/h5/#/pages/creation/faka-detail?mchOrderNo='+mchOrderNo
                   }else{
                     location.href=process.env['VUE_APP_SHARE_BASE']+  '/h5/#/pages/community/post-list?id='+this.busId+"&mchOrderNo="+mchOrderNo
                   }
                   // location.href='https://' + window.location.host  +"/#/creation?mchOrderNo="+res.data.mchOrderNo;
                 }else {
                   alert(res.err_msg)
                 }
               });
           /* eslint-disable */
         }

       })

     },
   }
 };
</script>
<style scoped lang="scss">

</style>